<template>
  <div class="nt-page" v-if="tiene_permiso">

    <!-- Hero -->
    <div class="nt-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-file-document-outline</v-icon>
        </v-avatar>
        <div>
          <div class="nt-hero__title">Listado de NITs</div>
          <div class="nt-hero__sub">Gestión de números de identificación tributaria</div>
        </div>
      </div>
      <div class="d-flex align-center" style="gap:8px;">
        <create-update-form
          v-if="$store.state.CARGO.id != 8 && $store.state.CARGO.id != 15 && $store.state.CARGO.id != 6"
          ref="refForm"
          :editedIndex.sync="editedIndex"
          v-on:newregnit="newregnit"
        />
        <v-btn small dark text @click="$router.back()">
          <v-icon left small>mdi-arrow-left</v-icon> Volver
        </v-btn>
      </div>
    </div>

    <div class="nt-body">

      <!-- Toolbar -->
      <v-card outlined class="nt-toolbar-card mb-4">
        <v-card-text class="py-2 px-4 d-flex flex-wrap align-center" style="gap:10px;">
          <v-text-field
            v-model="search"
            placeholder="Buscar NIT..."
            prepend-inner-icon="mdi-magnify"
            dense outlined hide-details clearable autofocus
            style="max-width:320px;"
          />
          <v-chip x-small :color="nits.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ nits.length }} registro{{ nits.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-progress-circular v-if="loading" indeterminate color="indigo" size="20" width="2" />
        </v-card-text>
      </v-card>

      <!-- Tabla -->
      <v-card outlined class="nt-table-card">
        <v-data-table
          :headers="headers"
          :items="nits"
          :search="search"
          :loading="loading"
          :items-per-page="-1"
          :item-class="itemRowBackground"
          hide-default-footer
          loader-height="3"
          loading-text="Cargando NITs..."
          no-data-text="Sin NITs registrados."
          dense
          class="nt-table"
        >
          <!-- Estado -->
          <template v-slot:[`item.status`]="{ item }">
            <v-chip x-small label
              :color="item.estado ? 'green lighten-5' : 'red lighten-5'"
              :class="item.estado ? 'green--text text--darken-3' : 'red--text text--darken-3'"
              class="font-weight-medium">
              <v-icon left x-small>{{ item.estado ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline' }}</v-icon>
              {{ item.status }}
            </v-chip>
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex" style="gap:4px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="teal darken-1" v-on="on" @click="detailItem(item)">
                    <v-icon>mdi-eye-outline</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalle</span>
              </v-tooltip>
              <v-tooltip bottom v-if="$store.state.CARGO.id != 8 && $store.state.CARGO.id != 15 && $store.state.CARGO.id != 6">
                <template v-slot:activator="{ on }">
                  <v-btn icon color="indigo darken-1" v-on="on" @click="editItem(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
            </div>
          </template>

        </v-data-table>
      </v-card>

    </div>

    <show-detail ref="refDetails" @showedit="editItem" />
  </div>

  <div class="pa-6 text-center" v-else>
    <v-icon color="red lighten-1" size="48">mdi-block-helper</v-icon>
    <div class="mt-2 red--text text--darken-1">Usuario no autorizado para visualizar este contenido.</div>
  </div>
</template>

<script>
import CreateUpdateForm from './CreateUpdateForm';
import ShowDetail from './ShowDetail';
import xaxios from '@/xaxios';

export default {
  components: { CreateUpdateForm, ShowDetail },
  data() {
    return {
      search: '',
      tiene_permiso: true,
      editedIndex: -1,
      loading: false,
      headers: [
        { text: 'ID',          value: 'id',               width: 70 },
        { text: 'Nombre',      value: 'nombre' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Número',      value: 'nro',              width: 130 },
        { text: 'Facturación', value: 'tipo_facturacion', width: 120 },
        { text: 'Estado',      value: 'status',           width: 110 },
        { text: 'Acciones',    value: 'actions',          width: 100, sortable: false },
      ],
      nits: [],
      json_fields: {
        id: 'id',
        Nombre: 'nombre',
        Descripcion: 'descripcion',
        Numero: 'nro',
        estado: 'status',
      },
    };
  },
  methods: {
    detailItem(item) {
      this.$refs.refDetails.showDialog(item);
    },
    editItem(item) {
      this.editedIndex = this.nits.indexOf(item);
      this.$refs.refForm.showDialog(item);
    },
    itemRowBackground(item) {
      return item.estado ? '' : 'nt-row-disabled';
    },
    newregnit(item) {
      let e = this.nits.find((x) => x.id == item.id);
      if (e) {
        e.nombre = item.nombre;
        e.descripcion = item.descripcion;
        e.tipo_facturacion = item.tipo_facturacion;
      }
    },
    getNits() {
      let vue = this;
      this.loading = true;
      xaxios.request({
        method: 'get',
        url: `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`,
        headers: {},
      }).then(function(response) {
        let data = response.data.data;
        data.map((x) => { x.status = x.estado ? 'Activo' : 'Suspendido'; });
        vue.nits = data;
        window.console.log(data);
        vue.loading = false;
      }).catch(function(error) {
        window.console.log(error);
        vue.loading = false;
      });
    },
  },
  async mounted() {
    this.getNits();
  },
};
</script>

<style scoped>
.nt-page { min-height: 100vh; background: #f5f7fa; }

.nt-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.nt-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.nt-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.nt-body { padding: 20px 24px; }

.nt-toolbar-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.nt-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.nt-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.nt-table >>> tbody tr:hover { background: #f0f4ff !important; }
.nt-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>

<style>
.nt-row-disabled { background-color: #fff0f0 !important; }
</style>
